import {Component, OnInit, ViewChild} from '@angular/core';
import { HttpEventType, HttpResponse } from "@angular/common/http";
import {MfaService} from "../../mfa.service";
import * as fileSaver from 'file-saver';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators} from "@angular/forms";
import {MessageService} from "../../message.service";
import {getAlertMessage} from "../../api-loaders";
import { GroupAssignmentStatus } from '../../models/GroupAssignmentStatus';
import { getTransactionStatusText, getStatusTextClassName, getTransactionStatusClass, TransactionStatus, getStatusIconClassNameByStatusId } from '../../../users/models/TransactionStatus';
import { firstValueFrom } from 'rxjs';
import { SecurityService } from '../../security.service';


@Component({
    selector: 're-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.scss'],
    standalone: false
})
export class FileUploadDialogComponent implements OnInit {

  @ViewChild('file', {static: false}) file;

  selectedFile: File;
  uploadForm: UntypedFormGroup;
  running = false;
  uploading = false;
  fileName = '';

  constructor(
              private mfaService: MfaService,
              private formBuilder: UntypedFormBuilder,
              private messageService: MessageService,
              private securityService: SecurityService
  ) {

    this.uploadForm = new UntypedFormGroup({
      fileUpload: new UntypedFormControl("", [Validators.required,(control: AbstractControl) => this.validateFileType(control)])
    });
  }
  statusText = "";
  status: GroupAssignmentStatus;
  statusClass = ""
  statusClassIcon = "";
  isSupportUser = false;
  async ngOnInit() {

    this.isSupportUser = await firstValueFrom(this.securityService.isSupportUser());
    this.statusText = "";
    this.statusClass = "";
    this.messageService.showSpinner();
    this.mfaService.getBulkUpdateProcessStatus().subscribe(x => {
      this.messageService.hideSpinner();
      this.status = x;
      this.statusClass = getTransactionStatusClass(this.status.statusId);
      this.statusText = getTransactionStatusText("Process", this.status.statusId);
      this.statusClassIcon = getStatusIconClassNameByStatusId(this.status.statusId);

    }, error => {
      this.messageService.hideSpinner();
      this.messageService.sendError(getAlertMessage(error).message);
    });
  }

  validateFileType(control: AbstractControl): ValidationErrors | null {
    this.selectedFile= this.file && this.file.nativeElement.files[0];
      return this.selectedFile && this.selectedFile.type === 'text/csv' ? null : {'invalidFileType': true};
  }

  onFileSelected() {
    const selectedFile: File = this.file.nativeElement.files[0];
    if (selectedFile) {
      this.fileName = selectedFile.name;
    }
  }

  selectFile() {
    this.file.nativeElement.click();
  }
  upload() {
    if (this.selectedFile) {
      this.uploading = true;
      this.messageService.showSpinner();
      this.mfaService.uploadBulkUpdateCsv(this.selectedFile).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            //
          } else if (event instanceof HttpResponse) {
            // call another API to pull the status
            this.uploading = false;
            this.selectedFile = null;
            this.fileName = null;
            this.messageService.sendSuccess("2FA bulk update is completed successfully.", true);
            this.uploadForm.reset();
          }
        },
        (error: any) => {
          this.messageService.sendError(getAlertMessage(error).message, true);
          this.uploading=false;
          this.selectedFile = null;
          this.fileName = null;
          this.uploadForm.reset();
        }
      )
    }
  }

  downloadMfaTemplate() {
    this.mfaService.downloadMfaBulkUpdateTemplate().subscribe(event => {
      if (event.type === HttpEventType.DownloadProgress) {
        window.status = `Receiving data ${event.loaded} `; // download percentage
      } else if (event instanceof HttpResponse) {
        fileSaver.saveAs(event.body, "2FABulkUpdateTemplate.csv", {type: "text/csv;charset=utf-8"});
      }
    }, e => {
      this.messageService.sendError(getAlertMessage(e).message);
    });
  }
}
